



const PhoneValidate = (value: any) => {
    const phoneRegex = /^(\+7|8)\s?\(?\d{3}\)?\s?\d{3}[-\s]?\d{2}[-\s]?\d{2}$/;

    return !phoneRegex.test(value);
}

export default PhoneValidate;